import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// (Optional) Google Analytics setup
// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-XXXXXXXXX-X'); // Replace with your tracking ID
// ReactGA.pageview(window.location.pathname + window.location.search);

// App lazy loading
const LazyApp = React.lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <React.Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/*" element={<LazyApp />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
